import type { CellStyle } from "ag-grid-community";

// Notes are free text in narrow data columns. Wrap at word boundaries rather
// than splitting a word mid-character, and let a word too wide for the column
// scroll horizontally inside its own cell instead of being broken up.
const WRAPPING_CELL_STYLE: CellStyle = {
  overflowWrap: "normal",
  wordBreak: "normal",
  overflowX: "auto",
};

/**
 * Resolves the cell style for a notes row. Notes rows get word-level wrapping
 * with horizontal scroll; every other row uses the grid default.
 */
export const getWrappingCellStyle = (
  isNotesRow: boolean,
): CellStyle | undefined => (isNotesRow ? WRAPPING_CELL_STYLE : undefined);
